import PropTypes from 'prop-types';
import {
  Button, IconAtencion, IconLoading, IconPreferences, IconSpeed, Modal,
} from 'gatorcomponents';
import React from 'react';
import * as Styles from './ActivateDeactivateInternalDomainModal.styles';
import { ORIGIN, STATUS } from '../../CloudFlareHandler.types';
import { cloudflareAnalytics } from '@/analytics/cloudflare';


export const ActivateDeactivateInternalDomainModal = ({
  onClose,
  onContinueActivating,
  onContinueDeactivating,
  toActivateTitle,
  activatingTitle,
  toDeactivateTitle = 'Desativar o CDN',
  deactivatingTitle = 'Desativação do CDN em andamento',
  toActivateDescription,
  activatingDescription,
  deactivatingDescription = 'Ative o CDN e deixe seu site mais rápido e seguro. As mudanças  podem levar até 24 horas.',
  toDeactivateDescription = 'Ative o CDN e deixe seu site mais rápido e seguro. As mudanças  podem levar até 24 horas.',
  cancelCta = 'Cancelar',
  confirmationCta = 'Ok, entendi',
  continueActivationCta = 'Ativar o CDN',
  continueDeactivationCta = 'Desativar o CDN',
  currentStatus = STATUS.NONEXISTENT,
  origin,
  loadingActivation,
  lastActivation,
  failedRequestTitle = 'Ocorreu um erro na sua solicitação',
  domainWithProblemTitle = 'Domínio temporariamente indisponível',
  failedRequestDescription = 'Algo deu errado enquanto processavamos sua solicitação. Por favor, tente novamente.',
  domainWithProblemDescription = ' Não foi possível ativar a CDN por conta de problemas no seu domínio, por favor, entre em contato com o seu registrante e confirme se há alguma pendência.',
}) => {
  const toActivate = [
    STATUS.NONEXISTENT,
    STATUS.INACTIVE,
    STATUS.DELAY,
    STATUS.ERROR,
    STATUS.INACTIVE_DELAY,
    STATUS.ACTIVATION_POINTING_ERROR,
    STATUS.INACTIVATION_POINTING_ERROR,
  ].includes(currentStatus);
  const successActivation = lastActivation.status === 'success';
  const failedActivation = lastActivation.status === 'failure';
  const domainWithProblem = failedActivation && lastActivation.message === 'frozen domain';

  const callToggleGaTag = () => {
    if (origin === ORIGIN.INTERNAL && currentStatus === STATUS.INACTIVE) {
      cloudflareAnalytics.activateHgDomainToggle();
      return;
    }
    if (origin === ORIGIN.INTERNAL && currentStatus === STATUS.ACTIVE) {
      cloudflareAnalytics.deactivateHgDomainToggle();
      return;
    }
    if (origin === ORIGIN.EXTERNAL && currentStatus === STATUS.INACTIVE) {
      cloudflareAnalytics.activateExternalDomainToggle();
      return;
    }
    if (origin === ORIGIN.EXTERNAL && currentStatus === STATUS.ACTIVE) {
      cloudflareAnalytics.deactivateExternalDomainToggle();
    }
  };

  const handleCancel = () => {
    onClose && onClose();
  };

  const handleContinue = () => {
    callToggleGaTag();

    if (toActivate) {
      onContinueActivating && onContinueActivating();
    }

    if (!toActivate) {
      onContinueDeactivating && onContinueDeactivating();
    }
  };

  const getTitle = () => {
    if (failedActivation) {
      return domainWithProblem ? domainWithProblemTitle : failedRequestTitle;
    }

    if (successActivation) {
      return toActivate ? activatingTitle : deactivatingTitle;
    }

    return toActivate ? toActivateTitle : toDeactivateTitle;
  };

  const getIcon = () => {
    if (failedActivation) {
      return <IconAtencion secondaryColor="problemLight" size="xl" />;
    }

    if (successActivation) {
      return <IconPreferences size="xl" />;
    }

    return (
      <IconSpeed
        secondaryColor={toActivate ? 'activePure' : 'problemLight'}
        size="xl"
        variant={toActivate ? 'fast' : 'slow'}
      />
    );
  };

  const getDescription = () => {
    if (failedActivation) {
      return domainWithProblem ? domainWithProblemDescription : failedRequestDescription;
    }

    if (successActivation) {
      return toActivate ? activatingDescription : deactivatingDescription;
    }

    return toActivate ? toActivateDescription : toDeactivateDescription;
  };

  const getContinueLabel = () => {
    if (loadingActivation) {
      return <IconLoading />;
    }

    return toActivate ? continueActivationCta : continueDeactivationCta;
  };

  return (
    <Modal onClose={onClose}>
      <Styles.Container id="activateDeactivateModalContainer">
        {getIcon()}

        <Styles.Title data-testid="title">
          {getTitle()}
        </Styles.Title>

        <Styles.Description data-testid="description">
          {getDescription()}
        </Styles.Description>

        <Styles.ActionsRow>
          {(successActivation || failedActivation) && (
            <Button
              size="large"
              testId="confirmation"
              label={confirmationCta}
              onClick={onClose}
            />
          )}

          {(!successActivation && !failedActivation) && (
          <>
            <Button
              size="large"
              testId="back"
              variant="tertiary"
              label={cancelCta}
              onClick={handleCancel}
              disabled={loadingActivation}
            />
            <Button
              size="large"
              testId="continue"
              label={getContinueLabel()}
              onClick={handleContinue}
              disabled={loadingActivation}
            />
          </>
          )}

        </Styles.ActionsRow>
      </Styles.Container>
    </Modal>
  );
};

ActivateDeactivateInternalDomainModal.propTypes = {
  onClose: PropTypes.func,
  onContinueActivating: PropTypes.func,
  onContinueDeactivating: PropTypes.func,
  toActivateTitle: PropTypes.string,
  activatingTitle: PropTypes.string,
  toDeactivateTitle: PropTypes.string,
  deactivatingTitle: PropTypes.string,
  toActivateDescription: PropTypes.string,
  activatingDescription: PropTypes.string,
  toDeactivateDescription: PropTypes.string,
  deactivatingDescription: PropTypes.string,
  cancelCta: PropTypes.string,
  confirmationCta: PropTypes.string,
  continueActivationCta: PropTypes.string,
  continueDeactivationCta: PropTypes.string,
  currentStatus: PropTypes.string,
  loadingActivation: PropTypes.bool,
  lastActivation: PropTypes.object,
  failedRequestTitle: PropTypes.string,
  failedRequestDescription: PropTypes.string,
};

export default ActivateDeactivateInternalDomainModal;
